import { BONE, ChainId, ChainTokenMap } from '@shibaswap/sdk';
import shibaSwapData from '@shibaswap/shibaswap-data-snoop';

export interface MerkleAmountAndProofs {
  uniqueId: string;
  rewardTokenName: string;
  amounts: any;
  merkel_root: any;
  distributorAddress: { [chainId in ChainId]?: string };
  tokenAddress: ChainTokenMap;
  decimals: number;
  fileName: string;
  vesting: any;
  disableLockInfo?: boolean;
  showComingSoon?: boolean;
  tooltip: string;
}

export const SeenOnChips: Array<{ key: string; img: string; href?: any }> = [
  {
    key: 'INSIDER',
    img: '/logos/insider.svg',
    href: 'https://markets.businessinsider.com/news/stocks/whale-moves-huge-amount-of-shiba-inu-as-token-unveils-to-metaverse-12069880',
  },
  {
    key: 'IBT',
    img: '/logos/IBT.svg',
    href: 'https://www.ibtimes.com/exclusive-shiba-inu-team-drops-massive-surprise-sets-new-standard-web3-experiences-following-3677114',
  },
  {
    key: 'BUSINESSWIRE',
    img: '/logos/bw.svg',
    href: 'https://www.businesswire.com/news/home/20230314005841/en/SHIB-The-Metaverse-To-Launch-On-Shibarium-Layer-2-Blockchain-Setting-New-Standard-for-Web3-Experiences',
  },
  {
    key: 'FASTCOMPANY',
    img: '/logos/fastcompany.svg',
    href: 'https://www.fastcompany.com/90857274/shiba-inu-coin-shib-shibarium-explained-blockchain-network',
  },
  {
    key: 'CMC',
    img: '/logos/CMC.svg',
    href: 'https://coinmarketcap.com/headlines/news/shiba-inu-paramount-collab-in-the-making/',
  },
  {
    key: 'NASDAQ',
    img: '/logos/nasdaq.svg',
    href: 'https://www.nasdaq.com/articles/shiba-inu-announces-the-launch-of-its-metaverse',
  },
  {
    key: 'BITCOINIST',
    img: '/logos/bitcoinist.svg',
    href: 'https://bitcoinist.com/shiba-inu-metaverse-live-views-unveiled-sxsw-texas/',
  },
  {
    key: 'THESTREET',
    img: '/logos/thestreet.svg',
    href: 'https://www.thestreet.com/crypto/news/shiba-inu-metaverse-comes-to-south-by-southwest',
  },
  {
    key: 'DAILYHODL',
    img: '/logos/dailyhodll.svg',
    href: 'https://dailyhodl.com/2023/03/12/shiba-inu-developer-reveals-first-look-at-coming-shib-metaverse/',
  },
  {
    key: 'YAHOOFINANCE',
    img: '/logos/yahoofinance.svg',
    href: 'https://finance.yahoo.com/news/shib-metaverse-launch-shibarium-layer-165700654.html',
  },
  {
    key: 'TAPCHI',
    img: '/logos/tapchi.svg',
    href: 'https://tapchibitcoin.io/shiba-inu-thong-bao-ra-mat-shib-the-metaverse-tren-shibarium.html',
  },
  {
    key: 'DAILYCOIN',
    img: '/logos/dailycoin.svg',
    href: 'https://dailycoin.com/shiba-inus-shib-the-metaverse-to-be-featured-at-sxsw-texas/',
  },
];
export const NavbarRouting: Array<{
  label: string;
  href?: string;
  className?: string;
  target?: string;
}> = [
  { label: 'landBuying', href: '#buyyourland' },
  { label: 'newmap', href: '#ryoshiplaza' },
  { label: 'updates', href: '#whatsnew' },
  { label: 'lapdogs', href: '#lapdogs' },
  { label: 'innovation', href: '#shapingfuture' },
  { label: 'faqs', href: '#faqs' },
];

export const getLocalizedFooterLinks = (locale: string, className?: string, target?: string) => [
  { label: 'Enter Land Map', href: `/${locale}/map`, className, target },
  { label: 'Shibarium', href: 'https://shib.io/shibarium/', target: '_blank' },
  { label: 'Shib.io', href: 'https://shib.io/', target: '_blank' },
  { label: 'Privacy Policy', href: `/${locale}/privacy-policy`, className, target },
  { label: 'Term of Use', href: `/${locale}/terms-of-use`, className, target },
];

export const mainNetworkChainId = ChainId.MAINNET;
export const puppyNetChainId = ChainId.PUPPYNET;
export const shibariumChainId = ChainId.SHIBARIUM;
export const sepoliaChainId = ChainId.SEPOLIA;

export const metadataURL =
  'https://shiboshis.mypinata.cloud/ipfs/QmUEiYGcZJWZWp9LNCTL5PGhGcjGvokKfcaCoj23dbp79J/';

export const shiberseContractAddresses = {
  [ChainId.MAINNET]: {
    LAND_SALE: '0xd3b65CE365233e272b46EF933366e2e86a22C37C',
    SHIB_TOKEN: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
    WETH_TOKEN: '',
  },
  [ChainId.SEPOLIA]: {
    LAND_SALE: '0x55E0829bb20268ea2a03F6dA5c566E78C8a2c15d',
    SHIB_TOKEN: '0xC6980A4Ad666D111d39Ef9F6e8b36EfeD0985121',
    WETH_TOKEN: '',
  },
  [ChainId.SHIBARIUM]: {
    LAND_SALE: '0xBd501998F668E491Cbc16FAb297e4B520A4Ce627',
    SHIB_TOKEN: '0x495eea66B0f8b636D441dC6a98d8F5C3D455C4c0',
    WETH_TOKEN: '0x8ed7d143Ef452316Ab1123d28Ab302dC3b80d3ce',
  },
  [ChainId.PUPPYNET]: {
    LAND_SALE: '0x153834e3c7aF5c5C950994d18aBe066c89C2EDfA',
    SHIB_TOKEN: '0xAc720702Df63fa92416B3dEB24Dc4a1854f73330',
    WETH_TOKEN: '0x0C477AE2E8E5ce1666468e44b066542Fa46f9F72',
  },
};

export const LAND_BONE_MERKLE_DISTRIBUTOR_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x860a79124538c778D9AaFaE5971DCD5D979a1afB',
};

export const BONE_REWARDS_MERKLE: MerkleAmountAndProofs = {
  uniqueId: '20',
  rewardTokenName: 'Bone Land Sales Reward',
  amounts: 'https://rewards-files.s3.amazonaws.com/BONE_LAND_REWARDS/BoneLandRewards/lockInfo.json',
  merkel_root: 'https://rewards-files.s3.amazonaws.com/BONE_LAND_REWARDS/BoneLandRewards/Merkle/',
  distributorAddress: LAND_BONE_MERKLE_DISTRIBUTOR_ADDRESS,
  tokenAddress: BONE,
  decimals: 18,
  fileName: 'boneLandRewards',
  vesting: shibaSwapData.buryshibBoneVesting,
  showComingSoon: false,
  tooltip: '',
};

export const constants = {
  SeenOnChips,
  NavbarRouting,
  getLocalizedFooterLinks,
  mainNetworkChainId,
  metadataURL,
  shiberseContractAddresses,
  BONE_REWARDS_MERKLE,
};
